// extracted by mini-css-extract-plugin
export default {"conversationResults__diagnosticResources":"conversationResults__diagnosticResources"};